import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { RespostaListaDinamicaComponent } from '../components/resposta-lista-dinamica.component';
import { RespostaListaDinamicaService } from '../services/resposta-lista-dinamica.service';
import { QuestionarioDinamicoService } from '../services/questionario-dinamico.service';
/** AngularMaterial **/
import { MatSelectModule, MatButtonModule, MatIconModule,  MatProgressSpinnerModule, MatSnackBarModule } from '@angular/material';
import { QuestionarioDinamicoModule } from './questionario-dinamico.module';
import { HttpService } from 'ems-oauth2-client';
import { RespostaQuestionarioService } from '../services/resposta-questionario.service';

/**
Lista de Componentes do MaterialDesign (importar somento o q for usar)
MaterialModule, MdAutocompleteModule, MdCheckboxModule, MdInputModule, MdRadioModule, MdSelectModule, MdSliderModule, MdSlideToggleModule, MdMenuModule, MdSidenavModule, MdToolbarModule, MdListModule, MdGridListModule, MdCardModule, MdTabsModule, MdButtonModule, MdButtonToggleModule, MdChipsModule, MdIconModule, MdProgressSpinnerModule, MdDialogModule, MdTooltipModule, MdSnackBarModule
**/

@NgModule({
    declarations: [
        RespostaListaDinamicaComponent
    ],
    exports: [
      RespostaListaDinamicaComponent
    ],
    imports: [
      FormsModule, CommonModule,
      MatSelectModule, MatButtonModule,  MatIconModule, MatProgressSpinnerModule, MatSnackBarModule,
      QuestionarioDinamicoModule
    ],
    providers: [
       RespostaListaDinamicaService, RespostaQuestionarioService, QuestionarioDinamicoService, HttpService
    ]
})
export class RespostaListaModule {
}
